import { ReactElement, useCallback, useEffect, useState } from 'react';

import { TextFieldProps } from '@mui/material';

import { CustomTextField } from '@/components/inputs/custom/CustomTextField';
import { setSearchStringFilter } from '../store';

export const SearchStringFilter = (): ReactElement => {
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchStringFilter(searchString);
    }, 800);

    return () => {
      clearTimeout(timer);
    };
  }, [searchString]);

  const handleSetSearchStringFilter = useCallback<
    NonNullable<TextFieldProps['onChange']>
  >((event) => {
    setSearchString(event.target.value);
  }, []);

  return (
    <CustomTextField
      fullWidth
      placeholder="Search ID, name or keyword, email, status"
      value={searchString}
      onChange={handleSetSearchStringFilter}
      slotProps={{
        input: {
          startAdornment: (
            <svg
              width="20"
              height="20"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                marginRight: '12px',
              }}
            >
              <path
                d="M14 14L11.1067 11.1067M12.6667 7.33333C12.6667 10.2789 10.2789 12.6667 7.33333 12.6667C4.38781 12.6667 2 10.2789 2 7.33333C2 4.38781 4.38781 2 7.33333 2C10.2789 2 12.6667 4.38781 12.6667 7.33333Z"
                stroke="#4C4C4C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        },
      }}
    />
  );
};
